import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import Iframe from './components/Iframe'
import { ILinkConverter } from './types'
import { ConditionalWrapper } from '../utils'
import getIdFromString from '../../utils/getIdFromString'

// MUI
import Link from '@mui/material/Link'
import Tooltip from '@mui/material/Tooltip'
import CookieComplianceWrapper from '../CookieComplianceWrapper'

const LinkConverter = ({
  linkHref,
  linkTitle,
  target,
  children,
  tabIndex,
  onKeyDown,
  isTooltip,
  isAnIframe,
  width,
  height,
  cookieConsent,
  onClick,
  sx,
}: ILinkConverter) => {
  const tooltipDescription = linkHref?.replace(/(^\w+:|^)\/\//, '') // This removes "https://" from tooltip, since it has no actual value for the user

  const cleanUrl = linkHref?.startsWith('https://tdc.dk') ? linkHref?.replace('https://tdc.dk', '') : linkHref

  if (isAnIframe) {
    const iframeProps = {
      linkHref: linkHref!,
      width,
      height,
      frameBorder: '0',
    }
    return (
      <ConditionalWrapper
        condition={Boolean(cookieConsent)}
        wrapper={children => (
          <CookieComplianceWrapper cookieConsent={cookieConsent!}>{children}</CookieComplianceWrapper>
        )}
      >
        <Iframe {...iframeProps} />
      </ConditionalWrapper>
    )
  }
  return (
    <ConditionalWrapper
      condition={isTooltip!}
      wrapper={children => (
        <Tooltip title={tooltipDescription} placement="bottom-start">
          {children}
        </Tooltip>
      )}
    >
      {cleanUrl?.startsWith('http') ? (
        <Link
          href={linkHref}
          onKeyDown={onKeyDown}
          rel={target === '_blank' ? 'noreferrer noopener' : ''}
          tabIndex={tabIndex || 0}
          target={target || ''}
          title={!isTooltip && linkTitle ? linkTitle : ''}
          id={`link-external-${linkTitle ? getIdFromString(linkTitle) : getIdFromString(linkHref!)}`}
          onClick={onClick}
          sx={sx || {}}
        >
          {children}
        </Link>
      ) : (
        <Link
          onKeyDown={onKeyDown}
          tabIndex={tabIndex || 0}
          title={!isTooltip && linkTitle ? linkTitle : ''}
          id={`link-external-${linkTitle ? getIdFromString(linkTitle) : getIdFromString(linkHref!)}`}
          onClick={onClick}
          sx={sx || {}}
          {...{
            component: GatsbyLink,
            to: cleanUrl,
          }}
        >
          {children}
        </Link>
      )}
    </ConditionalWrapper>
  )
}

export default LinkConverter
